import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service'
import { debounceTime } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements  CanActivate{

  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(public authService: AuthService, public router: Router, public configService: ConfigService) {
    this.loader$.pipe(debounceTime(300)).subscribe(loader => {this.loader = loader})
  }
 
  async canActivate(): Promise<boolean> {
    console.debug("AuthGuard");
    this.setShowLoader(true);
    try {
      var isLogged = await this.authService.checkAutentication();
      this.configService.getInitialInfo(true);
    } catch (error) {
      this.setShowLoader(false);
      this.router.navigateByUrl('/autenticacion')
      return false
    }
      if (isLogged){
        console.debug("isLogged true");
        this.setShowLoader(false);
        this.configService.getInitialInfo(true);
        return true
      }
      this.setShowLoader(false)
      this.router.navigateByUrl('/autenticacion');
      return false
  }  

  setShowLoader(show) {
    this.loader$.next(show)
  }
}

